import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import './styles/reset.css';
import './styles/theme.css';
import './styles/app.css';

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('Rot-elementet #root saknas');

createRoot(rootEl).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
